<template>
  <div id="SelectedProductTable">
    <b-table
      v-if="products"
      striped
      hoverable
      :data="products"
      :selected.sync="selected"
    >
      <template slot-scope="props">
        <b-table-column field="image" label="Image">
          <figure class="image is-128x128">
            <img class="cover-center" :src="props.row.main_image" />
          </figure>
        </b-table-column>

        <b-table-column field="name" label="Product Name">
          {{ props.row.name.en }}
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>Nothing here.</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import ProductApi from "@/apis/ProductApi";

export default {
  name: "SelectedProductTable",
  props: ["productId"],
  data() {
    return {
      products: null,
      selected: null
    };
  },
  watch: {
    selected: function(val) {
      if (val) {
        this.$emit("product_update", val);
      }
    }
  },
  methods: {
    getProductList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await ProductApi.requestProductList();
      loadingComponent.close();
      if (response && response.length > 0) {
        this.products = response;
        if (this.productId) {
          this.selected = this.products.find(
            item => item._id === this.productId
          );
        }
      }
    }
  },
  mounted() {
    this.getProductList();
  }
};
</script>

<style scoped>
.cover-center {
  height: 128px;
  object-position: center;
  object-fit: cover;
}
</style>
